import { alpha, makeStyles, Theme } from '@material-ui/core';
import { MODAL_HEIGHT } from './configuration';

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    minHeight: MODAL_HEIGHT,
    maxHeight: MODAL_HEIGHT,
    padding: '0 !important',
    borderTop: '0',
    borderBottom: 0,
  },
  filterTitle: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
    marginBottom: '10px',
    padding: '6px',
  },
  filterItem: {
    borderRadius: '8px',
    padding: '6px',
    cursor: 'pointer',
    '&:hover': {
      background: '#F2F4F5',
    },
  },
  filterItemSelected: {
    background: '#F2F4F5',
  },
  filterItemName: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '20px',
  },
  filterItemBrief: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14px',
    color: theme.palette.text.secondary,
  },
  action: {
    paddingTop: '8px',
    paddingBottom: '8px',
    textTransform: 'none',
    fontWeight: 'normal',
    borderRadius: '48px',
    marginRight: '14px',
    [theme.breakpoints.up('md')]: {
      width: '120px',
    },
  },
  propertyTypeItem: {
    border: `1px solid #E3E5E6`,
    borderRadius: '12px',
    background: 'white',
    width: '100%',
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid ${theme.palette.secondary.main}`,
      background: alpha(theme.palette.secondary.main, 0.05),
    },
  },
  propertyTypeItemSelected: {
    border: `1px solid ${theme.palette.secondary.main}`,
    background: alpha(theme.palette.secondary.main, 0.05),
  },
  boxInputSelect: {
    '& .MuiSelect-select': {
      // paddingTop: 12,
      // paddingBottom: 12,
    },
  },
  boxInput: {
    width: '100%',
    '& input': {
      padding: 10,
    },
  },
}));

export default useStyles;
